import type { ChatAttachmentInput } from "./types.js";

export type AfasAttachmentFile = {
  id: string;
  filename: string;
  size?: number;
  mimeType?: string;
  previewUrl?: string;
};

export function toAfasFile(
  attachment: ChatAttachmentInput,
  index: number,
  prefix = "attachment",
): AfasAttachmentFile {
  const contentType = getAttachmentContentType(attachment);
  const previewUrl = getAttachmentPreviewUrl(attachment, contentType);
  return {
    id: `${prefix}-${index}-${attachment.fileName}-${attachment.size}`,
    filename: attachment.fileName,
    size: attachment.size,
    mimeType: contentType,
    ...(previewUrl ? { previewUrl } : {}),
  };
}

function getAttachmentContentType(attachment: ChatAttachmentInput): string {
  return typeof attachment.contentType === "string" && attachment.contentType
    ? attachment.contentType
    : "application/octet-stream";
}

function getAttachmentPreviewUrl(
  attachment: ChatAttachmentInput,
  contentType: string,
): string | undefined {
  const data = attachment.data;
  if (!data || !contentType.toLowerCase().startsWith("image/")) {
    return undefined;
  }
  return `data:${contentType};base64,${data}`;
}
